var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Aggregate", {
    attrs: {
      title: "Demand",
      ItemConstructor: _vm.CaseModel.DemandProject,
      headers: [
        { text: "Name", value: "name" },
        { text: "Active", value: "active", width: 1 },
      ],
      cardProps: { flat: true, class: [] },
      "toolbar-dense": "",
    },
    on: {
      change: function ($event) {
        return _vm.$emit("change")
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "item.active",
          fn: function (ref) {
            var item = ref.item
            return [
              _c("v-switch", {
                attrs: { dense: "" },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: item.active,
                  callback: function ($$v) {
                    _vm.$set(item, "active", $$v)
                  },
                  expression: "item.active",
                },
              }),
            ]
          },
        },
        {
          key: "default",
          fn: function (ref) {
            var item = ref.item
            return [
              _c("InputGeo", {
                attrs: {
                  label: "Coordinates",
                  "map-height": "150",
                  nullable: "",
                  "switch-text": "Use Demand coordinates",
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: item.coordinates,
                  callback: function ($$v) {
                    _vm.$set(item, "coordinates", $$v)
                  },
                  expression: "item.coordinates",
                },
              }),
              _c("v-switch", {
                attrs: {
                  label: _vm.schema.scale.title,
                  hint: _vm.schema.scale.tooltip,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: item.scale,
                  callback: function ($$v) {
                    _vm.$set(item, "scale", $$v)
                  },
                  expression: "item.scale",
                },
              }),
              item.scale
                ? [
                    _c("InputYearly", {
                      attrs: {
                        label: "Peak Load",
                        suffix: "MW",
                        num_years: _vm.num_years,
                        year_start: _vm.year_start,
                      },
                      model: {
                        value: item.scale_peak,
                        callback: function ($$v) {
                          _vm.$set(item, "scale_peak", $$v)
                        },
                        expression: "item.scale_peak",
                      },
                    }),
                    _c("InputYearly", {
                      attrs: {
                        label: "Annual Load",
                        suffix: "GWh",
                        num_years: _vm.num_years,
                        year_start: _vm.year_start,
                      },
                      model: {
                        value: item.scale_annual,
                        callback: function ($$v) {
                          _vm.$set(item, "scale_annual", $$v)
                        },
                        expression: "item.scale_annual",
                      },
                    }),
                  ]
                : _vm._e(),
              _c("InputYearlyProfile", {
                attrs: {
                  label: _vm.schema.profile.title,
                  suffix: _vm.schema.profile.unit,
                  num_years: _vm.num_years,
                  "profile-type": _vm.schema.profile.profileType,
                  "multi-year-upload": true,
                  "object-value": "",
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: item.profile,
                  callback: function ($$v) {
                    _vm.$set(item, "profile", $$v)
                  },
                  expression: "item.profile",
                },
              }),
              _c("InputYearlyProfile", {
                attrs: {
                  label: _vm.schema.voll.title,
                  suffix: _vm.schema.voll.unit,
                  num_years: _vm.num_years,
                  year_start: _vm.year_start,
                  fill: "",
                  "fill-value": 0,
                  "object-value": "",
                  "items-type": "constant",
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: item.voll,
                  callback: function ($$v) {
                    _vm.$set(item, "voll", $$v)
                  },
                  expression: "item.voll",
                },
              }),
              _c(
                "v-expansion-panels",
                {
                  staticClass: "mx-0 px-0",
                  attrs: { tile: "", multiple: "", accordion: "", flat: "" },
                },
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c(
                        "v-expansion-panel-header",
                        { staticClass: "text-subtitle-1 font-weight-medium" },
                        [_vm._v("Services ")]
                      ),
                      _c(
                        "v-expansion-panel-content",
                        [
                          _c("SystemProjectServices", {
                            attrs: {
                              year_start: _vm.year_start,
                              num_years: _vm.num_years,
                              "resource-type": "demand",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: item.services,
                              callback: function ($$v) {
                                _vm.$set(item, "services", $$v)
                              },
                              expression: "item.services",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
    model: {
      value: _vm.computedValue,
      callback: function ($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }